import { useEffect, useState } from 'react';
import { Image, ImageProps, Skeleton, Flex } from '@chakra-ui/react';
import config from '../../config';

export type AvatarImageProps = Omit<ImageProps, 'onError'> & {
    onErrorImageSrcs?: string[];
};

export const AvatarImage: React.FC<AvatarImageProps> = ({
    src,
    onErrorImageSrcs = [config.avatarPlaceholderURL],
    ...rest
}) => {
    const [fallbackCount, setFallbackCount] = useState(0);
    const [imgSrc, setImgSrc] = useState<string | undefined>(undefined);

    useEffect(() => {
        setImgSrc(src);
    }, [src]);

    function onError() {
        console.log(`count: ${fallbackCount}`);
        if (fallbackCount < onErrorImageSrcs.length) {
            console.log('updated: ' + onErrorImageSrcs[fallbackCount]);
            setImgSrc(onErrorImageSrcs[fallbackCount]);
            setFallbackCount(fallbackCount + 1);
        }
    }

    return (
        <>
            {imgSrc === '' || imgSrc === undefined ? (
                <Skeleton height="100%" width="100%" {...rest} />
            ) : (
                <Flex className={'avatar-image-container'}>
                    <Image
                        src={imgSrc}
                        fallback={<Skeleton height="100%" width="100%" />}
                        onError={onError}
                        {...rest}
                    />
                </Flex>
            )}
        </>
    );
};
